import { Injectable } from '@angular/core';
import { ApiService } from '../api-service/api.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class ProductsService {

	private _products: BehaviorSubject<any>

  constructor(private apiService: ApiService) {

  	this._products = new BehaviorSubject({})
  	this.retrieveProducts()

   }

   get products(){
  		return this._products
  	}

  	retrieveProducts(){

  		this.apiService.request('GET', '/products')
  		.then((response)=>{
  			this._products.next(response)
  		})
  		.catch(error=>{
  			console.log(error)
  		})

  	}


}



// WEBPACK FOOTER //
// /Users/matthewspringbett/sites/cycler/apollo-admin/src/src/app/products-service/products.service.ts